import React from 'react'
import styled from 'react-emotion'
import PropTypes from 'prop-types'
import { themeGet as th } from 'styled-system'

import { SEARCH, FOLDER, DRAFTS } from 'constants/ticket_list_types'
import Options from 'components/SearchModifier/Options'
import { Flex, theme, themePropTypes } from 'shared/ui'

const FilterBar = ({ className, titleType, searchIsFolderSearch }) => {
  return (
    <Flex pt={2} pl={4} pr={4} className={className}>
      <div className="filters">
        {!searchIsFolderSearch && titleType === SEARCH && <Options />}
      </div>
    </Flex>
  )
}

FilterBar.propTypes = {
  titleType: PropTypes.oneOf([SEARCH, FOLDER, DRAFTS]).isRequired,
  searchIsFolderSearch: PropTypes.bool.isRequired,
  /* Theme */
  theme: themePropTypes.theme.isRequired,
}

FilterBar.defaultProps = {
  titleType: SEARCH,
  searchIsFolderSearch: false,
  theme,
}

FilterBar.displayName = 'FilterBar'

export default styled(FilterBar)`
  border-bottom: 1px solid ${th('colors.borderGray')};
  line-height: ${th('fontSizes.3')}px;

  .filters {
    flex: 1 0 auto;
    display: flex;
    justify-content: center;

    > * {
      flex-basis: auto;
      flex-grow: 1;
      flex-shrink: 1;
      color: inherit;
    }
  }
`
